module.exports = __webpack_public_path__ + "media/a2.9b7aa757.mp3";